<template>
  <div>
    <el-row :gutter="16" class="stat-grid">
      <el-col v-for="card in cards" :key="card.label" :xs="24" :sm="12" :md="8" :lg="6">
        <div class="stat-card">
          <div class="stat-label">{{ card.label }}</div>
          <div class="stat-value" :class="card.money ? 'money-font' : ''">{{ card.value }}</div>
          <div class="stat-desc">{{ card.desc }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :xs="24" :lg="14">
        <div class="page-card chart-card">
          <div class="toolbar"><h3 class="toolbar-title">月度买入/卖出趋势</h3></div>
          <div ref="chart" class="chart"></div>
        </div>
      </el-col>
      <el-col :xs="24" :lg="10">
        <div class="page-card">
          <div class="toolbar"><h3 class="toolbar-title">最近卖出</h3></div>
          <el-table :data="recent.sales" size="small" height="288" empty-text="暂无卖出记录">
            <el-table-column prop="brandName" label="品牌" min-width="90" />
            <el-table-column prop="itemNo" label="货号" min-width="110" />
            <el-table-column prop="salePrice" label="卖价" width="100"><template slot-scope="scope">¥{{ money(scope.row.salePrice) }}</template></el-table-column>
            <el-table-column prop="profit" label="利润" width="100"><template slot-scope="scope"><span :class="Number(scope.row.profit || 0) >= 0 ? 'profit-positive' : 'profit-negative'">¥{{ money(scope.row.profit) }}</span></template></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <div class="page-card recent-card">
      <div class="toolbar"><h3 class="toolbar-title">最近购买</h3></div>
      <el-table :data="recent.purchases" size="small" empty-text="暂无购买记录">
        <el-table-column prop="brandName" label="品牌" min-width="100" />
        <el-table-column prop="itemNo" label="货号" min-width="130" />
        <el-table-column prop="category" label="品类" width="90" />
        <el-table-column prop="size" label="尺码" width="90" />
        <el-table-column prop="purchasePrice" label="买入价" width="120"><template slot-scope="scope">¥{{ money(scope.row.purchasePrice) }}</template></el-table-column>
        <el-table-column prop="purchaseDate" label="购买时间" width="120" />
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { dashboardSummary, dashboardMonthly, dashboardRecent } from '@/api/dashboard'
import { money } from '@/utils/format'

export default {
  name: 'Dashboard',
  data() {
    return { summary: {}, monthly: [], recent: { purchases: [], sales: [] }, chart: null }
  },
  computed: {
    cards() {
      return [
        { label: '当前库存', value: this.summary.stockCount || 0, desc: '尚未卖出的商品' },
        { label: '已卖出', value: this.summary.soldCount || 0, desc: '完成卖出登记' },
        { label: '总买入成本', value: `¥${this.money(this.summary.totalPurchaseCost)}`, money: true, desc: '所有记录买入价合计' },
        { label: '库存成本', value: `¥${this.money(this.summary.stockCost)}`, money: true, desc: '库存中商品成本' },
        { label: '总销售额', value: `¥${this.money(this.summary.totalSaleAmount)}`, money: true, desc: '已卖出商品收入' },
        { label: '总利润', value: `¥${this.money(this.summary.totalProfit)}`, money: true, desc: '卖价 - 成本 - 费用' },
        { label: '本月买入', value: `¥${this.money(this.summary.monthPurchaseAmount)}`, money: true, desc: '本月采购金额' },
        { label: '本月卖出', value: `¥${this.money(this.summary.monthSaleAmount)}`, money: true, desc: '本月销售金额' }
      ]
    }
  },
  mounted() { this.load(); window.addEventListener('resize', this.resizeChart) },
  beforeDestroy() { window.removeEventListener('resize', this.resizeChart); if (this.chart) this.chart.dispose() },
  methods: {
    money,
    async load() {
      const [summary, monthly, recent] = await Promise.all([dashboardSummary(), dashboardMonthly(), dashboardRecent()])
      this.summary = summary || {}; this.monthly = monthly || []; this.recent = recent || { purchases: [], sales: [] }
      this.$nextTick(this.renderChart)
    },
    renderChart() {
      if (!this.chart) this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption({ color: ['#2563eb', '#10b981', '#f59e0b'], tooltip: { trigger: 'axis' }, legend: { top: 0, data: ['买入金额', '卖出金额', '利润'] }, grid: { left: 48, right: 20, top: 46, bottom: 36 }, xAxis: { type: 'category', data: this.monthly.map(i => i.month) }, yAxis: { type: 'value' }, series: [{ name: '买入金额', type: 'bar', data: this.monthly.map(i => i.purchaseAmount || 0) }, { name: '卖出金额', type: 'bar', data: this.monthly.map(i => i.saleAmount || 0) }, { name: '利润', type: 'line', smooth: true, data: this.monthly.map(i => i.profit || 0) }] })
    },
    resizeChart() { if (this.chart) this.chart.resize() }
  }
}
</script>

<style scoped>
.stat-grid { margin-bottom: 16px; }
.stat-card { margin-bottom: 16px; padding: 18px; min-height: 130px; background: #fff; border: 1px solid #e4e4e7; border-radius: 16px; }
.stat-label { color: #71717a; font-size: 13px; }
.stat-value { margin-top: 12px; font-size: 28px; font-weight: 800; color: #18181b; }
.stat-desc { margin-top: 8px; color: #a1a1aa; font-size: 12px; }
.chart-card { margin-bottom: 16px; }
.chart { height: 300px; }
.recent-card { margin-top: 16px; }
</style>
